import { useQuery } from '@tanstack/react-query';

import { getTicketRequestCategories } from 'api/ticketRequestCategories';
import { RequestQueryKeysE, RequestStaleTimeE } from 'declarations/enums/react-query';
import { ApiErrorI } from 'declarations/interfaces/errors';
import { TicketRequestCategoryI } from 'declarations/interfaces/ticketRequestCategories';

export const useFetchTicketRequestCategories = (
  isNewTicketPopupOpened: boolean,
  roofTopId?: string
) => {
  return useQuery<TicketRequestCategoryI[], ApiErrorI>(
    [RequestQueryKeysE.FetchTicketRequestCategories, roofTopId],
    () => getTicketRequestCategories(roofTopId),
    {
      enabled: isNewTicketPopupOpened && !!roofTopId,
      staleTime: RequestStaleTimeE.TicketRequestCategories,
    }
  );
};
